export default __webpack_public_path__ + "static/media/e46e32a729649b41751db560a0bc6f64.svg";